import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface ArticleCardProps {
  id: string;
  title: string;
  excerpt: string;
  author: string;
  date: string;
  image: string;
  tags: string[];
  categoryName: string;
}

export default function ArticleCard({ id, title, excerpt, author, date, image, tags, categoryName }: ArticleCardProps) {
  const { t } = useTranslation();

  return (
    <article className="group cursor-pointer animate-scale-in">
      <Link to={`/article/${id}`} className="block">
        <div className="relative rounded-lg overflow-hidden aspect-[16/10] bg-background-200">
          <img
            src={image}
            alt={title}
            title={`${title} - 黄瓜视频在线观看`}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
            loading="lazy"
          />
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded text-xs font-medium bg-accent-500 text-background-50 whitespace-nowrap">
            {categoryName}
          </span>
        </div>
      </Link>
      <div className="mt-3">
        <Link to={`/article/${id}`}>
          <h3 className="text-base font-heading font-medium text-foreground-900 line-clamp-2 group-hover:text-primary-500 transition-colors leading-snug">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-500 mt-1.5 line-clamp-2 leading-relaxed">{excerpt}</p>
        <div className="flex items-center gap-3 mt-2.5 text-xs text-foreground-400">
          <span>{author}</span>
          <span>{date}</span>
        </div>
        <div className="flex flex-wrap gap-1.5 mt-2">
          {tags.slice(0, 2).map((tag) => (
            <span key={tag} className="px-2 py-0.5 rounded-full text-xs bg-secondary-100 text-secondary-700 whitespace-nowrap">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}